import Cookie from 'js-cookie';

import {
    AddBillingAddressRequestBody,
    AddDonationRequestBody,
    AddItemRequestBody,
    AddPaymentMethodRequestBody,
    AddPrescriptionBody,
    ApplyPromoCodeRequestBody,
    CartCreateBody,
    CartUI,
    DeliveryOptionsPost,
    PickupInfoRequestBody,
    PlaceOrderRequestBody,
    RemoveItemRequestBody,
    SetShippingMethodRequestBody,
    TreatPointRequestBody,
    UpdateItemFulfillmentMethodRequestBody,
    UpdateItemQtyRequestBody,
    UpdateSddDropoffAddressRequestBody,
} from '@libs/common-node';
import { AUTH_COOKIES, AUTH_HEADERS, apiFetch, COOKIES, getAccessToken, type HttpMethod } from '@libs/core';

export const getHeaders = () => {
    const headers: HeadersInit = {};
    // get header values
    const accessToken = getAccessToken();
    const anonymousKey = Cookie.get(AUTH_COOKIES.PETM_ANONYMOUS_KEY);
    const cartId = Cookie.get(COOKIES.CART_ID);
    const deviceType = Cookie.get(COOKIES.X_PETM_CHANNEL);
    const visitorId = Cookie.get(COOKIES.X_PETM_VISITOR_ID);

    if (accessToken) {
        headers[AUTH_HEADERS.AUTHORIZATION] = `Bearer ${accessToken}`;
    }

    if (cartId) {
        headers[AUTH_HEADERS.X_PETM_CART_ID] = cartId;
    }

    if (anonymousKey && !accessToken) {
        headers[AUTH_HEADERS.X_PETM_ANONYMOUS_KEY] = anonymousKey;
    }

    if (deviceType) {
        headers[AUTH_HEADERS.X_PETM_CHANNEL] = deviceType;
    }

    if (visitorId) {
        headers[AUTH_HEADERS.X_PETM_VISITOR_ID] = visitorId;
    }

    return headers;
};

const fetchCart = async <T = CartUI | null>(
    url: string,
    method: HttpMethod,
    body?:
        | CartCreateBody
        | AddItemRequestBody
        | UpdateItemQtyRequestBody
        | UpdateItemFulfillmentMethodRequestBody
        | RemoveItemRequestBody
        | AddDonationRequestBody
        | PickupInfoRequestBody
        | AddBillingAddressRequestBody
        | ApplyPromoCodeRequestBody
        | AddPaymentMethodRequestBody
        | PlaceOrderRequestBody
        | SetShippingMethodRequestBody
        | TreatPointRequestBody
        | AddPrescriptionBody
        | DeliveryOptionsPost
        | UpdateSddDropoffAddressRequestBody
        | { addressId: number },
    additionalHeaders?: { [key: string]: string },
    additionalSuccessCodes: number[] = [303, 400],
    requestInit?: RequestInit
): Promise<T | null> =>
    apiFetch<T | null>(url, {
        ...requestInit,
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            ...getHeaders(),
            ...additionalHeaders,
        },
        additionalSuccessCodes,
    }) as Promise<T | null>;

export default fetchCart;
